import axios from 'axios';

const API_URL = 'https://dev-api.thoorigai.net/api/v1/marquee';

const handleApiError = (error) => {
  if (error.response?.data) {
    return error.response.data;
  }
  return { success: false, message: 'An error occurred' };
};

export const getAllMarqueeTexts = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/get-all-marquee-texts`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

const marqueeTextService = {
  getAllMarqueeTexts,
};

export default marqueeTextService;
